import Bowser, { OS_MAP } from "bowser";
import React from "react";
import { Document } from "../../../api";
import { PdfViewer } from "./PdfViewer";

interface DocumentViewerProps {
  document: Document;
  availableWidth: number;
  availableHeight: number;
}

interface DocumentViewerState {
  usePdfViewer: boolean;
}

export const DocumentViewerComponent = class extends React.Component<DocumentViewerProps, DocumentViewerState> {
  constructor(props: DocumentViewerProps) {
    super(props);

    const browserResult = Bowser.parse(window.navigator.userAgent);

    // Use the PDF.js-based PDF viewer if using an iOS device, including an iPad requesting Desktop Mode
    const usePdfViewer =
      browserResult.os.name === OS_MAP.iOS || (browserResult.os.name === OS_MAP.MacOS && "ontouchstart" in window);

    this.state = {
      usePdfViewer,
    };
  }

  public componentDidMount() {
    window.addEventListener("resize", this.forceReRender);
  }

  public render() {
    const { document, availableWidth, availableHeight } = this.props;
    const { usePdfViewer } = this.state;

    let src = `/api/documents/${document.id}/file`;

    // HACK: This is (hopefully) temporary to allow a locally maintained copy of a PDF for Visitor Orientation...
    if (document.remoteFileUrl) {
      src = document.remoteFileUrl;
    }

    return (
      <div
        id={"document-container"}
        className={"document-viewer-container"}
        style={{ height: availableHeight - 2, overflowY: usePdfViewer ? "scroll" : undefined }}
      >
        {usePdfViewer ? (
          <PdfViewer src={src} availableWidth={availableWidth} />
        ) : (
          <iframe title="Document Preview" src={src} />
        )}
      </div>
    );
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this.forceReRender);
  }

  private forceReRender = () => {
    this.forceUpdate();
  };
};

export const DocumentViewer = DocumentViewerComponent;
